/**
 *
 * Asynchronously loads the component for Can
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
